import { Component, OnInit} from '@angular/core';
import { ConfigService } from '../../../../infrastructure/services/config.service';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '../../../../infrastructure/services/alert.service';

@Component({
  templateUrl: './historial-importacion.component.html',
})
export class HistorialImportacionComponent implements OnInit {
  preguntar: any = [];
  codSistema: string;
  historial: any;
  constructor(private route: ActivatedRoute,
              private alertService: AlertService,
              private configService: ConfigService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.codSistema = params['codsistema'];

      this.configService.getHistorialImportacion(this.codSistema).subscribe(res => {
        this.historial = res.data;
      });
    });
  }

  volverAEstaVersion(historialId) {
    this.preguntar[historialId] = false;

    this.configService.aplicarVersion(this.codSistema, historialId)
      .then(res => {
        this.alertService.showSuccessMessage('SUCCESSFUL_ROLLBACK');
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/initializer/historial/historial-importacion.component.ts